import styled from "styled-components";
import { device } from "./mediaQuery";
export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  @media ${device.landscapeMobile} {
    flex-direction: column;
  }
`;
export const Content = styled.div`
  width: 95.5%;
  height: 100vh;
  @media ${device.desktops} {
    width: 94%;
  }
  @media ${device.landscapeMobile} {
    width: 100%;
    height: auto;
  }
`;

export const Page = styled.div`
  width: 87%;
  margin-left: auto;
  margin-right: auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  @media ${device.mobile} {
    width: 90%;
  }
  @media ${device.landscapeMobile} {
    height: auto;
    min-height: 88vh;
  }
`;

export const Tags = styled.span`
  color: ${(props) => props.theme.colorsPalette.primaryColor};
  opacity: 0.6;
  font-size: 18px;
  font-family: "La Belle Aurore";
`;
export const TopTags = styled(Tags)`
  padding-top: 1.5%;
`;
export const BottomTags = styled(Tags)`
  padding-bottom: 1.5%;
  @media ${device.landscapeMobile} {
    margin-top: 3%;
  }
`;

export const MiddleContent = styled.div`
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media ${device.mobile} {
    flex-direction: column;
  }
`;
